export default {
    getLogsMyFhe: (fromDate, toDate) => {
        return {
            url: '/logs/env/:env',
            method: 'GET',
            route_params: {
                env: 'myfhe'
            },
            get_params: {
                fromDate,
                toDate
            }
        };
    }
};



// WEBPACK FOOTER //
// ./environments/logging/data/LogsMyFhe/api.js